import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as newUserPasscodeState from '../reducers/new-user-passcode.reducer';

import * as fromAuthReducer from '../auth.reducer';

//#region AUTH ROOT STATE
export const getAuthState = createFeatureSelector<fromAuthReducer.State, fromAuthReducer.AuthState>(fromAuthReducer.authFeatureKey);
//#endregion

//#region NEW USER PASSCODE STATE
export const getNewUserPasscodeState = createSelector(getAuthState, state => state[newUserPasscodeState.newUserPasscodeFeatureKey]);
//#endregion

export const getNewUserPasscodeIsLoading = createSelector(getNewUserPasscodeState, newUserPasscodeState.getNewUserPasscodesIsLoading);
export const getNewUserPasscodeRequest = createSelector(getNewUserPasscodeState, newUserPasscodeState.getNewUserPasscodesRequest);
export const getNewUserPasscodeSuccess = createSelector(getNewUserPasscodeState, newUserPasscodeState.getNewUserPasscodesResponse);
export const getNewUserPasscodeFailure = createSelector(getNewUserPasscodeState, newUserPasscodeState.getNewUserPasscodesFailure);
